export const SUGGESTED_QUESTIONS = 'Suggested Questions';
export const APPOINTMENT_NOTEBOOK = 'Appointment Notebook';
export const FILTERS_APPLIED = 'Filters Applied:';
export const APPOINTMENTS = 'Appointments';
export const UNDATED_NOTES = 'Undated Notes';
export const CLEAR_ALL = 'Clear All';
export const ADD = 'Add';
export const ADD_APPOINTMENT_CONTENT = 'Let’s add your first appointment';
export const ADD_NEW_APPOINTMENT = 'Add New Appointment';
export const APPOINTMENT_TITLE_TOAST_ERROR_MESSAGE = 'Please enter the appointment title to save the changes';
export const ARCHIVE_APPOINTMENT_TITLE = 'Archive Appointment';
export const ARCHIVE_NOTE_TITLE = 'Archive Note';
export const UNARCHIVE_APPOINTMENT_TITLE = 'Unarchive Appointment';
export const UNARCHIVE_NOTE_TITLE = 'Unarchive Note';
export const ARCHIVE_APPOINTMENT_CONTENT = 'Are you sure you want to archive appointment note for';
export const ARCHIVE_NOTE_CONTENT = 'Are you sure you want to archive note titled';
export const UNARCHIVE_APPOINTMENT_CONTENT = 'Are you sure you want to Unarchive';
export const UNARCHIVE_NOTE_CONTENT = 'Are you sure you want to Unarchive';
export const NOTE = 'note';
export const APPOINTMENT = 'appointment';
export const SHOW_ARCHIVE_APPOINTMENTS = 'Show Archive Appointments';
export const APPOINTMENT_SEARCH_PLACEHOLDER = 'Search by Doctor Name or Type';
export const APPOINTMENT_SUMMARY = 'Appointment Summary';

export const PREPARE_FOR_APPOINTMENT = 'Prepare for Appointment';
export const DURING_APPOINTMENT = 'During Appointment';
export const FOLLOW_UP = 'Follow Up';

export const APPOINTMENT_INFO = 'Appointment Info';
export const APPOINTMENT_INFO_SUBTITLE =
    'Did you know doctors & medical teams prepare for appointments? They appreciate when patients & families are also prepared.';

export const QUESTION_FOR_CARE_TEAM_TITLE = 'Questions for care team';
export const QUESTION_FOR_CARE_TEAM_SUBTITLE =
    'Write down questions for the appointment. For ideas, look at the map or reach out to the guide.';

export const SYMPTOMS_TITLE = 'Symptoms';
export const SYMPTOMS_SUBTITLE =
    'Doctors rely on you to accurately report symptoms so they can tailor the treatment. Note symptoms, how bad they are and what you did about them';

export const MEDICATIONS_TITLE = 'Medications';
export const MEDICATIONS_SUBTITLE = 'Your care team relies on having an updated list of active medications and supplements.';

export const NOTES_TITLE = 'Notes';
export const NOTES_SUBTITLE = 'Taking notes in the appointment is critical. Type directly here.';

export const ADDITIONAL_TESTING_TITLE = 'Additional Testing';
export const ADDITIONAL_TESTING_SUBTITLE = 'Note any additional tests that need to be completed.';

export const MEDICATION_CHANGES_TITLE = 'Changes to medication or lifestyle';
export const MEDICATION_CHANGES_SUBTITLE =
    'Note any changes the medical team needs you to make to medications, supplements, nutrition, and/or exercise.';

export const FOLLOW_UP_TITLE = 'Any other follow-up';
export const FOLLOW_UP_SUBTITLE = 'Note any other follow ups that the team requires you to do. You can attach images to these notes.';

export const APPOINTMENT_ADD_MESSAGE = 'appointment has been added successfully';
export const APPOINTMENT_EDIT_MESSAGE = 'appointment has been edited successfully';
